export default {
  DELETE_FILE_SUCCESS: 'Le contenu a été supprimé avec succès.',
  ADD_CONTENT: 'Ajouter du contenu à partager',
  ADD_CONTENT_INFO: 'Téléchargez ici vos documents, liens, images ou autres matériels pour les partager avec vos visiteurs.',
  NO_CONTENT: 'Vous n’avez pas encore ajouté de fichiers ou de liens!',
  UPLOAD_FILES: 'Télécharger des fichiers',
  ADD_URL: 'Ajouter une URL',
  ADDED_CONTENT: 'Fichiers et URL ajoutés',
  URL: 'Url',
  ADD_URL_SUCCESS: 'URL générée et sauvegardée avec succès!',
  DISPLAY_NAME: 'Nom d’affichage',
  BROCHURE: 'Brochure',
  CHOOSE_FILE: 'Choisir un fichier',
  DRAG_DROP: 'Glisser-déposer',
  TO_UPLOAD: 'pour télécharger',
  MAX_FILE_SIZE: 'La taille maximale autorisée est de 3mb',
  MAX_LEN_ERR: 'Le nom du fichier est trop long',
  MAX_SIZE_ERR: 'La limite de taille du fichier est dépassée',
  FILES_UPLOAD_SUCCESS: 'Fichiers téléchargés avec succès'
}
